import React from "react";
import { Button, message, Modal, Table, Tooltip, Typography } from "antd";

const data = [
  {
    group: 'Job',
    variable: 'job',
    keys: [
      { name: 'Name', variable: 'name' },
      { name: 'Merchant Reference', variable: 'merchant_reference' },
      { name: 'Area', variable: 'area' },
      { name: 'Architect', variable: 'building.architect_name' },
      { name: 'Take Off', variable: 'take_off.take_off_type' },
      { name: 'Merchant', variable: 'merchant.name' },
    ]
  },
]

// initializing "full_variable" for easier copy in the table
for (const group of data) {
  for (const item of group.keys) {
    item.full_variable = `[${group.variable}.${item.variable}]`;
  }
}

const dataSource = data.reduce((acc, group) => [...acc, group, ...group.keys], []);

export default function ModalContentHelper({ visible = false, onClose }) {
  const columns = [
    { key: 'group', title: 'Group', dataIndex: 'group' },
    { key: 'name', title: 'Name', dataIndex: 'name' },
    {
      key: 'variable',
      title: 'Variable',
      dataIndex: 'variable',
      render: (val) => val && (
        <Typography.Text code>
          {val}
        </Typography.Text>
      ),
    },
    {
      key: 'action',
      title: '',
      render: (_, record) => record.full_variable && (
        <Tooltip title="Copy variable to clipboard" placement="left" mouseLeaveDelay={0}>
          <Button
            size="small"
            icon="copy"
            onClick={() => {
              navigator.clipboard.writeText(record.full_variable)
                .then(() => message.info('Variable copied.'))
                .catch(() => message.error('Failed to copy variable, please try copying manually.'));
            }}
          />
        </Tooltip>
      ),
    },
  ]

  return (
    <Modal
      title="Tag Content Variables"
      visible={visible}
      // bodyStyle={{ padding: '0.75rem' }}
      style={{ minWidth: 500, maxWidth: '90%' }}
      width={1000}
      onCancel={onClose}
      footer={null}
    >
      <div className="mb-2">
        The format for writing variables in Tags is <Typography.Text code>[variable_group.variable_name]</Typography.Text>, for example <Typography.Text code>[job.name]</Typography.Text>
      </div>
      <Table
        // bordered
        size="small"
        className="styled-table-small"
        columns={columns}
        dataSource={dataSource}
        pagination={false}
      />
    </Modal>
  )
}